var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contact-ec-cell" },
    [
      _vm.editStatus
        ? [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.checkBoxValue,
                  expression: "checkBoxValue",
                },
              ],
              attrs: { disabled: _vm.disabledCheckboxOnEdit, type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.checkBoxValue)
                  ? _vm._i(_vm.checkBoxValue, null) > -1
                  : _vm.checkBoxValue,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.checkBoxValue,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.checkBoxValue = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.checkBoxValue = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.checkBoxValue = $$c
                  }
                },
              },
            }),
            _vm._v(" "),
            _vm.canAccess
              ? _c("span", { staticClass: "icon-remove" }, [
                  _c("i", {
                    staticClass: "fa fa-times-thin",
                    on: { click: _vm.deleteItem },
                  }),
                ])
              : _vm._e(),
          ]
        : [
            _vm.isUntickedOnRead
              ? _c("span", [_vm._v(_vm._s(_vm.$t("emptyValue")))])
              : _c("input", {
                  attrs: { disabled: true, type: "checkbox" },
                  domProps: { checked: _vm.record.isVendorCircular },
                }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }